import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { API_URL } from '../config/apiConfig';
import safeSessionStorage from '../utils/safeSessionStorage';

const BetaBanner = () => {
  const [banner, setBanner] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const location = useLocation();

  // Hide on showcase pages so it doesn't block the toolbar/navigation
  const isShowcasePage = location.pathname.startsWith('/collection/');

  useEffect(() => {
    // Check if already dismissed this session
    if (safeSessionStorage.getItem('beta_banner_dismissed') === 'true') {
      setDismissed(true);
      return;
    }

    const fetchBetaStatus = async () => {
      try {
        const response = await fetch(`${API_URL}/public/beta-status`);
        if (response.ok) {
          const data = await response.json();
          if (data.enabled && data.message) {
            setBanner(data);
          }
        }
      } catch (err) {
        // Silently fail — no banner is fine
      }
    };

    fetchBetaStatus();
  }, []);

  const handleDismiss = () => {
    setDismissed(true);
    safeSessionStorage.setItem('beta_banner_dismissed', 'true');
  };

  if (!banner || dismissed || isShowcasePage) return null;

  return (
    <div style={{
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: '#fff',
      padding: '10px 20px',
      fontSize: '13px',
      fontWeight: '500',
      textAlign: 'center',
      position: 'relative',
      zIndex: 1000,
      letterSpacing: '0.01em',
      lineHeight: '1.4',
    }}>
      <span>{banner.message}</span>
      <button
        onClick={handleDismiss}
        aria-label="Dismiss beta banner"
        style={{
          position: 'absolute',
          right: '12px',
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'rgba(255,255,255,0.2)',
          border: 'none',
          color: '#fff',
          fontSize: '14px',
          cursor: 'pointer',
          borderRadius: '50%',
          width: '24px',
          height: '24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          lineHeight: '1',
          padding: 0,
          transition: 'background 0.15s',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.35)'; }}
        onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.2)'; }}
      >
        ✕
      </button>
    </div>
  );
};

export default BetaBanner;
